import { render, staticRenderFns } from "./SSOErro.vue?vue&type=template&id=e4fdfd84&scoped=true&"
import script from "./SSOErro.vue?vue&type=script&lang=js&"
export * from "./SSOErro.vue?vue&type=script&lang=js&"
import style0 from "./SSOErro.vue?vue&type=style&index=0&id=e4fdfd84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fdfd84",
  null
  
)

export default component.exports